import axios from 'axios';

const api = axios.create({
//   baseURL: 'http://localhost:5000/api'
//   baseURL: 'https://your-backend-app.onrender.com/api'
  baseURL: 'https://mongodb-ihbj.onrender.com/api'
});

// Add token to requests automatically
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // ✅ Changed from 'authToken' to 'token'
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token'); // ✅ Changed from 'authToken' to 'token'
      localStorage.removeItem('usn'); // ✅ Added usn removal
      localStorage.removeItem('user'); // ✅ Added user removal
      localStorage.removeItem('userId'); // ✅ Added userId removal
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
